import { useLayoutEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CommandNames } from 'utils/constants/swarm/swarm-command-names';
import { TMarketType, TMarketTypeResponse } from 'interfaces/sportsbook';
import { swarmCommand } from 'services/get-swarm-data';
import { setMarketType, setMarketTypes } from 'store/actions';
import { getAdvancedSportsForMarketsTypes } from 'store/selectors/new-sportsbook';

const SENT_REQUESTS_BY_SPORT_ALIAS: Record<string, boolean> = {};

export const useAdvancedMarkets = (doNotUseCache?: boolean) => {
  const dispatch = useDispatch();
  const sportAliases = useSelector(getAdvancedSportsForMarketsTypes);

  useLayoutEffect(() => {
    const promiseMarketsSwarmRequest: Promise<Record<string, TMarketType[]>>[] =
      [];

    if (sportAliases.length) {
      sportAliases.forEach(sportAlias => {
        if (
          sportAlias &&
          (doNotUseCache || !SENT_REQUESTS_BY_SPORT_ALIAS[sportAlias])
        ) {
          SENT_REQUESTS_BY_SPORT_ALIAS[sportAlias] = true;

          promiseMarketsSwarmRequest.push(
            new Promise(resolve => {
              swarmCommand(
                CommandNames.GET_MARKET_TYPE,
                { sport_alias: sportAlias },
                (data: TMarketTypeResponse) => {
                  if (!data.details) {
                    return;
                  }

                  const markets = data.details
                    .sort((a, b) => a.Order - b.Order)
                    .map(
                      ({
                        MarketTypeName,
                        BasaltKind,
                        SelectionTypesNames
                      }) => ({
                        label: MarketTypeName.replace(
                          /\{sw\}|\{pw\}|\{s\}/g,
                          ''
                        ),
                        value: BasaltKind,
                        selectionTypesNames: SelectionTypesNames
                      })
                    );

                  resolve({ [sportAlias]: markets });
                }
              );
            })
          );
        }
      });

      if (promiseMarketsSwarmRequest.length) {
        Promise.all(promiseMarketsSwarmRequest).then(marketsData => {
          let markets: { [key: string]: TMarketType[] } = {};
          marketsData.forEach(data => {
            markets = { ...data, ...markets };
          });

          const sportAlias = Object.keys(markets).sort()[0];

          if (doNotUseCache) {
            dispatch(setMarketTypes(markets));
            dispatch(setMarketType({ [sportAlias]: markets[sportAlias][0] }));
          } else {
            dispatch(setMarketTypes(markets));
            dispatch(setMarketType({ [sportAlias]: markets[sportAlias][0] }));
          }
        });
      }
    }
  }, [sportAliases.length]);
};
